import { ColumnTypes } from "components/collections/util/datatypes";

import lazyCall from "components/util/helpers/LazyCall";
const exportExcelFile = lazyCall("exportExcelFile", "components/collections/util/excel");
const exportCSVFile = lazyCall("exportCSVFile", "components/collections/util/excel");

const TableCallbacks = ({
	_rows,
	_columns,
	collectionOptions = {},
	cacheRef,
	isReadOnly,
	useCustomImport,
	useCustomExport,
	formValue,
	setIsFormModalShown,
	setRows,
	setSearch,
	setQuery,
	setFilters,
	setSorting,
	setSelectedCell,
	setIsEditingcell,
	onClickImport,
	onClickExport,
	onClickCell,
	onDoubleClickCell,
	updateSearch,
	updateQuery,
	updateFilters,
	updateSorting,
	_onAddRow,
	_onChangeRow,
}) => {

	const _onClickImport = (importedRows, isOverwrite) => {
		if (useCustomImport) {
			onClickImport(importedRows, isOverwrite);
		}
		else {
			importedRows = importedRows.map(row => ({ data: row }));
			setRows(isOverwrite ? importedRows : [..._rows, ...importedRows]);
		}
	}

	const _onClickExport = (extension) => {

		if (useCustomExport) {
			onClickExport(extension);
			return;
		}

		if (extension == "csv")
			exportCSVFile({
				collections: collectionOptions,
				columns: _columns,
				rows: _rows,
				fileName: "export.csv",
				delimiter: ";",
			});
		else
			exportExcelFile({
				collections: collectionOptions,
				columns: _columns,
				rows: _rows,
				fileName: "export.xlsx",
				primaryKey: "id",
			});

	};

	const _updateSearch = (value) => {
		const id = Math.random();
		cacheRef.current["search"] = id;
		setTimeout(() => {
			if (cacheRef.current["search"] == id) {
				setSearch(value);
				updateSearch(value);
			}
		}, 600);
	}

	const _updateQuery = (query) => {
		setQuery(query);
		updateQuery(query);
	}

	const _updateFilter = (filters) => {
		setFilters(filters);
		updateFilters(filters);
	}

	const _updateSorting = (sorting) => {
		setSorting(sorting);
		updateSorting(sorting);
	}

	const _onClickCell = (rowData, row, column) => {
		setSelectedCell({ row, column });
		if (isReadOnly || _columns[column].type == ColumnTypes.OBJECT) return;
		onClickCell(rowData, row, column);
	}

	const _onDoubleClickCell = () => {
		if (isReadOnly) return;
		setIsEditingcell(true);
	}

	const _onBlurCell = () =>
		setIsEditingcell(false);

	const _onClickSubmitForm = (values) => {

		if (formValue) {
			const index = _rows.findIndex(row => row.id === formValue.id);
			_onChangeRow([
				..._columns.map((col) => ({
					name: col.name,
					value: values[col.name]
				}))
			]);
		}
		else {
			_onAddRow(Object.assign({}, values));
		}

		setIsFormModalShown(false);

	}

	return {
		_onClickImport,
		_onClickExport,
		_onClickCell,
		_onDoubleClickCell,
		_onBlurCell,
		_onClickSubmitForm,
		_updateSearch,
		_updateQuery,
		_updateFilter,
		_updateSorting,
	}

}

export default TableCallbacks;